import { defineMessages } from 'react-intl';

export const scope = 'axionoee.features.components.sensordatadiagramsettings';

export default defineMessages({
    readingTypeNameColumn: {
        id: `${scope}.grid.column.readingTypeName`,
        defaultMessage: 'Name',
    },
    readingTypeDescriptionColumn: {
        id: `${scope}.grid.column.readingTypeDescription`,
        defaultMessage: 'Description',
    },
    channelColumn: {
        id: `${scope}.grid.column.channel`,
        defaultMessage: 'Channel',
    },
    axisColumn: {
        id: `${scope}.grid.column.axis`,
        defaultMessage: 'Axis',
    },
    dataTypeColumn: {
        id: `${scope}.grid.column.dataType`,
        defaultMessage: 'Data Type',
    },
    sensorColumn: {
        id: `${scope}.grid.column.sensor`,
        defaultMessage: 'Sensor',
    },
    sortOrderColumn: {
        id: `${scope}.grid.column.sortOrder`,
        defaultMessage: 'Sort Order',
    },
    visibleColumn: {
        id: `${scope}.grid.column.visible`,
        defaultMessage: 'Visible',
    },
    conversionFactorColumn: {
        id: `${scope}.grid.column.conversionFactor`,
        defaultMessage: 'Conversion Factor',
    },
    minThresholdColumn: {
        id: `${scope}.grid.column.minThreshold`,
        defaultMessage: 'Min Threshold',
    },
    maxThresholdColumn: {
        id: `${scope}.grid.column.maxThreshold`,
        defaultMessage: 'Max Threshold',
    },
    showReadingType: {
        id: `${scope}.showReadingType`,
        defaultMessage: 'Show reading type',
    },
    backButtonTooltip: {
        id: `${scope}.backButtonTooltip`,
        defaultMessage: 'Back to diagram',
    },
    save: {
        id: `${scope}.save`,
        defaultMessage: 'Save',
    },
    editReadingType: {
        id: `${scope}.editReadingType`,
        defaultMessage: 'Edit reading type',
    },
    editThresholds: {
        id: `${scope}.editThresholds`,
        defaultMessage: 'Edit thresholds',
    },
    enableHighLimit: {
        id: `${scope}.enableHighLimit`,
        defaultMessage: 'Enable high threshold',
    },
    highLimitValue: {
        id: `${scope}.highLimitValue`,
        defaultMessage: 'High limit',
    },
    highLimitInstruction: {
        id: `${scope}.highLimitInstruction`,
        defaultMessage: 'High threshold instruction',
    },
    highLimitMinuetesOverThreshold: {
        id: `${scope}.highLimitMinuetesOverThreshold`,
        defaultMessage: 'Minutes over threshold',
    },
    highLimitCheckMachineInStatus: {
        id: `${scope}.highLimitCheckMachineInStatus`,
        defaultMessage: 'Check machine in status',
    },
    highLimitMachineInRunningStatus: {
        id: `${scope}.highLimitMachineInRunningStatus`,
        defaultMessage: 'Machine in running status',
    },
    enableLowLimit: {
        id: `${scope}.enableLowLimit`,
        defaultMessage: 'Enable low threshold',
    },
    lowLimitValue: {
        id: `${scope}.lowLimitValue`,
        defaultMessage: 'Low limit',
    },
    lowLimitInstruction: {
        id: `${scope}.lowLimitInstruction`,
        defaultMessage: 'Low threshold instruction',
    },
    lowLimitMinuetesOverThreshold: {
        id: `${scope}.lowLimitMinuetesOverThreshold`,
        defaultMessage: 'Minutes over high threshold',
    },
    lowLimitCheckMachineInStatus: {
        id: `${scope}.lowLimitCheckMachineInStatus`,
        defaultMessage: 'Check machine in status',
    },
    lowLimitMachineInRunningStatus: {
        id: `${scope}.lowLimitMachineInRunningStatus`,
        defaultMessage: 'Machine in running status',
    },
    machineRunningStatusRunning: {
        id: `${scope}.machineRunningStatusRunning`,
        defaultMessage: 'Running',
    },
    machineRunningStatusStopped: {
        id: `${scope}.machineRunningStatusStopped`,
        defaultMessage: 'Stopped',
    },
    minuetesOverThresholdHelpText: {
        id: `${scope}.minuetesOverThresholdHelpText`,
        defaultMessage: 'The value needs to be over the threshold for the specified amount of minutes before an alarm is triggered.',
    },
});